import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import AppHeader from '../../components/AppHeader';
import AppFooter from "../../components/AppFooter";
import PropTypes from "prop-types";

Result.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
}

export default function Result(props) {
    return (
        <div className="page">
            <AppHeader title="Bedankt"/>

            <div className="page-middle">
                <h1 className="pick-title">Bedankt voor uw aanvraag, we gaan er direct mee aan de slag!</h1>
            </div>
            <AppFooter onNext={props.handleNextPage}
                       last={true}
            />
        </div>
    );
}
